// extracted by mini-css-extract-plugin
module.exports = {"AltLayout":"AltLayout_AltLayout__nFasZ","Main":"AltLayout_Main__YfeAH"};